export default {
    title: 'Providers',
    table: {
        header: {
            name: 'Name',
            discount_module: 'Discount module',
            contact_phone: 'Contact phone',
            contact_actions: 'Contact',
        }
    },
    card: {
        discount_module: 'Discount module',
        discount_on: 'On',
        discount_off: 'Off',
        contact: 'Support contact',
        phone: 'Phone',
        email: 'Email',
        site: 'Site',
        address: 'Address',
        lat: 'Latitude',
        lng: 'Longitude',
        empty_contact: 'No contact configured yet. Add it so the app can show support details.',
        create_contact: 'Create contact',
        edit_contact: 'Update contact',
        no_providers: 'No providers found.',
        shown_in_app: 'Shown in mobile app',
        load_error: 'Could not load providers. Please try again.',
        discount_error: 'Could not update discount module. Please try again.',
        discount_success: 'Discount module updated.',
    },
    contact_modal: {
        title: 'Edit provider contact',
        site: 'Site',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        lat: 'Latitude',
        lng: 'Longitude',
        save: 'Save',
        cancel: 'Cancel',
        success: 'Provider contact saved.',
        save_error: 'Could not save provider contact.',
        site_hint_vd: 'For Vouchers Depot, brand name is appended to site in the app (prefix + brand).',
        validation: {
            email_invalid: 'Enter a valid email address.',
            site_invalid: 'Site must start with https://',
            phone_too_long: 'Phone must be at most 100 characters.',
            email_too_long: 'Email must be at most 255 characters.',
            site_too_long: 'Site must be at most 500 characters.',
            address_too_long: 'Address must be at most 500 characters.',
            lat_invalid: 'Latitude must be a number between -90 and 90.',
            lng_invalid: 'Longitude must be a number between -180 and 180.',
            form_invalid: 'Please fix the highlighted fields.',
        },
    }
}
